module.exports = __webpack_public_path__ + "img/book-cover.56b62ed1.png";